import {Table} from '@app/components/shared/table/model/table';
import {Row} from '@app/components/shared/table/model/row';
import {ActionsIds} from '@app/components/shared/table/action-ids';
import {Race} from '@app/rest-client/faxe/models/race';



export const mapRaces = (
  items: Race[]): Table<Race> => ({
  showPaginator: true,
  columns: [
    {header: 'Namn', property: 'raceName'},
    {header: 'Equipe-Referens', property: 'equipeMeetingsID'},
    {property: 'menu', menuItem: [{header: 'Ta bort', action: ActionsIds.delete}, {header: 'Ändra...', action: ActionsIds.edit}]}
  ],
  rows: toRow(items)
});

export const toRow = (
  races: Race[],
): Row<Race>[] => races ? races.map(m => {

    const rowRaceDataItem: Row<Race> = ({
      row: m,
      highligt: '',
    });

    return rowRaceDataItem;
  }
) : undefined;
